<div class="freezeMenu" *ngIf="isFreeze$ | async"></div>
<div (mouseenter)="onMouseEnter($event)" class="wrapper" [class.is-execute-ia]="isExecuteIaUser">
    <ng-container *ngIf="menu$ | async as menu">
        <div class="leftside-wrapper">
            <a routerLink="project">
                <p-panaya-logo></p-panaya-logo>
            </a>
            <ng-container *ngIf="menu.mode === menuMode.DEFAULT">
                <div>
                    <button
                        mat-button
                        class="mega-menu-button"
                        [ngClass]="{ 'mega-menu-highlight': displayMegaMenu }"
                        (click)="toggleDisplay()"
                        (focusout)="focusout($event)"
                        [attr.automation-id]="menu.title | translate"
                    >
                        <p-icon name="menu" size="lg"></p-icon>
                        <span
                            class="mega-menu-button__label"
                            [matTooltip]="menu.title | translate"
                            [showOnlyWhenEllipsis]="true"
                        >
                            {{ menu.title | translate }}
                        </span>
                    </button>

                    <p-mega-menu-container *ngIf="displayMegaMenu" (close)="focusout($event)"> </p-mega-menu-container>
                </div>

                <div class="nav-item-wrapper" *ngLet="myItems$ | async as myItems">
                    <p-nav-item
                        *ngFor="let menuItem of menu.items; trackBy: menuId"
                        [item]="menuItem"
                        [routerState]="routeState$ | async"
                        [badge]="isIcr3Project ? undefined : menuItem.id ? badgeArray[menuItem.id] : undefined"
                        [myItems]="myItems"
                        (itemClicked)="itemClicked($event)"
                        (badgeClicked)="gotoMyItems($event)"
                    >
                    </p-nav-item>
                </div>
            </ng-container>
        </div>

        <p-settings *ngIf="menu.mode === menuMode.SETTINGS" [data]="menu.items" [previousPath]="currentPath" [iconColor]="isExecuteIaUser ? 'base-dark' : 'base-light'"> </p-settings>

        <div class="actions">
            <p-main-header-actions
                *ngIf="actions$ | async as actions"
                class="action"
                [actions]="actions"
                [iconColor]="isExecuteIaUser ? 'base-dark' : 'base-light'"
                [preventOpenSearch]="preventOpenSearch$ | async"
                (iconClickedEvent)="iconClicked($event)"
            >
            </p-main-header-actions>
            <p-ai-chat-widget
                id="headerChat"
                *ngIf="isChatFeatureEnable"
                [isDraggable]="true"
                [draggableBoundaryClass]="'draggable-boundary'"
            ></p-ai-chat-widget>
            <p-user-menu></p-user-menu>
        </div>
    </ng-container>
</div>
